export const EVENT_COOKIE_ID = 'ebEventId';
